export default __webpack_public_path__ + "assets/images/aistudio/empty_state/8c7f4f2e43287d6fa8e3560d6e2e917e.png";